import MBadge from "./MBadge.vue";
export default MBadge;
